import {createContext} from 'react'

const VentaMostradorContext = createContext()

export default VentaMostradorContext